import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import PortalVue from 'portal-vue'
import VueLazyLoad from 'vue-lazyload'
import VueTouch from 'vue-touch'

// TO DO: uncomment dashboard when dashboard page built
// import Dashboard from '@/pages/dashboard.vue'
import Clients from '@/pages/client/clients.vue'
import ClientOverview from '@/pages/client/client-overview.vue'
import ClientsEdit from '@/pages/client/clients-edit.vue'
import ClientsAdd from '@/pages/client/clients-add.vue'
import ClientsInvoices from '@/pages/client/client-invoices.vue'
import ClientsCampaigns from '@/pages/client/campaigns/client-campaigns.vue'
import Campaigns from '@/pages/campaigns/campaigns.vue'
import CampaignCreatives from '@/pages/campaigns/campaign-creatives.vue'
import CreativeUnits from '@/pages/creatives/creative-units'
import SingleCreativeUnits from '@/pages/creatives/single-creative-unit'
import Projects from '@/pages/projects.vue'
import Templates from '@/pages/templates.vue'
import GIFPreview from '@/pages/dev/gif-preview.vue'
import JPGPreview from '@/pages/dev/jpg-preview.vue'
import PNGPreview from '@/pages/dev/png-preview.vue'
import HTMLPreview from '@/pages/dev/html-preview.vue'
import NOPreview from '@/pages/dev/no-preview.vue'
import Profile from '@/pages/profile.vue'
import Users from '@/pages/user/users.vue'
import UsersAdd from '@/pages/user/users-add.vue'
import UsersEdit from '@/pages/user/users-edit.vue'
import Assets from '@/pages/assets.vue'
import Links from '@/pages/links.vue'
import Tags from '@/pages/tags/overview.vue'
import TagsDetail from '@/pages/tags/detail.vue'
import TagsCreative from '@/pages/tags/creative.vue'
import DownloadFile from '@/pages/downloads/file.vue'
import PreviewStaging from '@/pages/preview-staging.vue'
import Admin from '@/pages/admin.vue'
import RenderQueueManager from '@/pages/render-queue-manager.vue'
import Help from '@/pages/help.vue'
import Login from '@/pages/login.vue'
import Invoices from '@/pages/invoice/invoices.vue'
import InvoiceBreakdown from '@/pages/invoice/invoice-breakdown.vue'
import PageNotFound from '@/pages/404.vue'
import ReviewLinksType from '@/pages/review-links-type.vue'
import ForgotPassword from '@/pages/forgot-password.vue'

import store from '@/store'
import ls from 'local-storage'

Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(PortalVue)
Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })

const router = new Router({
  mode: 'history',
  routes: [
    // { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/', name: 'Clients', component: Clients },
    { path: '/client/add', name: 'ClientsAdd', component: ClientsAdd, meta: {requiresAdmin: true} },
    { path: '/client/:id', name: 'ClientOverview', component: ClientOverview },
    { path: '/client/:id/edit', name: 'ClientsEdit', component: ClientsEdit, meta: {requiresAdmin: true} },
    { path: '/client/:id/invoices', name: 'ClientsInvoices', component: ClientsInvoices },
    { path: '/client/:id/campaigns', name: 'ClientsCampaigns', component: ClientsCampaigns },
    { path: '/campaigns', name: 'Campaigns', component: Campaigns },
    { path: '/campaigns/:id', name: 'CampaignCreatives', component: CampaignCreatives },
    { path: '/creatives/:id/bulk', name: 'CreativeUnits', component: CreativeUnits },
    { path: '/creatives/:id/single/:sid', name: 'SingleCreativeUnits', component: SingleCreativeUnits },
    { path: '/projects', name: 'Projects', component: Projects },
    { path: '/templates', name: 'Templates', component: Templates },
    { path: '/preview.gif', name: 'GIFPreview', component: GIFPreview },
    { path: '/preview.jpg', name: 'JPGPreview', component: JPGPreview },
    { path: '/preview.png', name: 'PNGPreview', component: PNGPreview },
    { path: '/preview.html', name: 'HTMLPreview', component: HTMLPreview },
    { path: '/no-preview', name: 'NOPreview', component: NOPreview },
    { path: '/profile', name: 'Profile', component: Profile },
    { path: '/users', name: 'Users', component: Users, meta: {requiresAdmin: true} },
    { path: '/user/add', name: 'UsersAdd', component: UsersAdd, meta: {requiresAdmin: true} },
    { path: '/user/:id/edit', name: 'UsersEdit', component: UsersEdit, meta: {requiresAdmin: true} },
    { path: '/assets', name: 'Assets', component: Assets },
    { path: '/links', name: 'Links', component: Links },
    { path: '/links/:type/list', name: 'ReviewLinksType', component: ReviewLinksType },
    { path: '/tags', name: 'Tags', component: Tags },
    { path: '/tags/detail/:id', name: 'TagDetail', component: TagsDetail },
    { path: '/tags/creative/:id', name: 'TagCreative', component: TagsCreative },
    { path: '/download/file/:id', name: 'DownloadFile', component: DownloadFile },
    { path: '/preview-staging', name: 'PreviewStaging', component: PreviewStaging },
    { path: '/admin', name: 'Admin', component: Admin, meta: {requiresAdmin: true} },
    { path: '/render-queue-manager', name: 'RenderQueueManager', component: RenderQueueManager, meta: {requiresAdmin: true} },
    { path: '/help', name: 'Help', component: Help },
    { path: '/login', name: 'Login', component: Login },
    { path: '/invoices', name: 'Invoices', component: Invoices, meta: {requiresAdmin: true} },
    { path: '/invoice/full/:id', name: 'InvoiceBreakdown', component: InvoiceBreakdown },
    { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
    { path: '/reset-password', name: 'PasswordReset', component: ForgotPassword },
    { path: '*', name: 'PageNotFound', component: PageNotFound }
  ]
})

router.beforeEach((to, from, next) => {
  // use local storage to persist state
  const user = ls.get('ot-user')

  // check if logged in
  if (!user && (to.name !== 'Login' && to.name !== 'ForgotPassword' && to.name !== 'PasswordReset')) {
    // if no user in local storage, call API to check whether or not they are actually logged in
    store.dispatch('profile/getProfileUser').then(() => {
      const loggedInUser = store.state.profile.user
      ls.set('ot-user', loggedInUser)
      // if not logged in redirect to login
      if (!loggedInUser) {
        ls.remove('ot-user')
        next({path: '/login', redirect: '/login'})
      } else {
        next({path: '/'})
      }
    }, () => {
      ls.remove('ot-user')
      next({path: '/login', redirect: '/login'})
    })
  }

  const isAdmin = user && user.role === 1 // is admin user
  const isClientAdmin = user && user.role === 4 // is client admin user

  // check authorisation for logged in users
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (isAdmin || isClientAdmin) {
      next()
    } else {
      next({path: '/'})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js